import { Env } from './types';

export const currentEnv: Env =
  (process.env.REACT_APP_API_ENV as Env) ?? Env.Stage;

export const isProd = currentEnv === Env.Prod;
